export const dismissText = "I know what I want to ask";
export const closeText = "Close question prompt pop up";

export enum questionsPromptPopUpTopics {
    StudentLife = "Student life",
    TheArea = "The area",
    Academics = "Academics",
    Accommodation = "Accommodation",
    Careers = "Careers",
    Support = "Support",
}

export const questionPromptTopicObject = {
    [questionsPromptPopUpTopics.StudentLife]: [
        "🎉 What’s the best thing about student life?",
        "🤝 Is it easy to make friends, especially in the first year?",
        "😲 What’s something unexpected about life here?",
        "🎊 Are there must-attend events or traditions?",
    ],
    [questionsPromptPopUpTopics.TheArea]: [
        "🌆 What’s your favorite thing to do off-campus?",
        "💃 What’s the nightlife, food scene, or social life like?",
        "💰 Is the city student-friendly and affordable?",
        "🗺️ Any hidden gems you’d recommend checking out?",
    ],
    [questionsPromptPopUpTopics.Academics]: [
        "📚 What’s the workload like?",
        "👩‍🏫 Do you feel supported by professors/tutors?",
        "💡 What’s been the most interesting part of your studies?",
        "⏳ How many hours do you study each week?",
    ],
    [questionsPromptPopUpTopics.Accommodation]: [
        "🏠 What’s the accommodation like?",
        "🔎 Is it easy to find housing after first year?",
        "👍👎 What’s the best and worst thing about where you live?",
        "🍳 Do most students cook or rely on campus food?",
    ],
    [questionsPromptPopUpTopics.Careers]: [
        "💼 Are there good internship or work opportunities while studying?",
        "🛒 How easy is it to get a part-time job?",
        "🎓 Do you feel prepared for jobs after graduation?",
        "🤝 How useful is the careers team or alumni network?",
    ],
    [questionsPromptPopUpTopics.Support]: [
        "🧠 How is student well-being and mental health support?",
        "📖 Is there good academic support if you’re struggling?",
        "📢 How easy is it to get career advice or internship guidance?",
        "🤗 Do students look out for each other here?",
    ],
};
